import React from 'react';
import { ArrowRight, Truck, Award, Users } from 'lucide-react';
import { Button } from './ui/button';

export const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative pt-40 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50 via-white to-gray-100"></div>
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, #8B1538 0px, #8B1538 1px, transparent 1px, transparent 20px)',
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block">
              <span className="inline-flex items-center px-4 py-2 rounded-full bg-[#8B1538]/10 text-[#8B1538] text-sm font-semibold border border-[#8B1538]/20">
                Ihr zuverlässiger Partner seit Jahren
              </span>
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Baustoffe für
              <span className="block text-[#8B1538] mt-2">höchste Ansprüche</span>
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              Deutschlandweite Lieferung von Premium-Baumaterialien für Bauunternehmen, Handwerker und Bauträger. Qualität, Zuverlässigkeit und Termintreue – darauf können Sie bauen.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => scrollToSection('kontakt')}
                size="lg"
                className="bg-[#8B1538] hover:bg-[#6B0F2A] text-white px-8 py-6 text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
              >
                Jetzt Anfrage stellen
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button
                onClick={() => scrollToSection('gewerke')}
                size="lg"
                variant="outline"
                className="border-2 border-gray-300 hover:border-[#8B1538] hover:text-[#8B1538] px-8 py-6 text-lg transition-all duration-300"
              >
                Unsere Gewerke
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-[#8B1538]/10 flex items-center justify-center">
                  <Truck className="w-5 h-5 text-[#8B1538]" />
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-lg">Deutschlandweit</div>
                  <div className="text-sm text-gray-600">Schnelle Lieferung</div>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-[#8B1538]/10 flex items-center justify-center">
                  <Award className="w-5 h-5 text-[#8B1538]" />
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-lg">Premium</div>
                  <div className="text-sm text-gray-600">Qualität</div>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-[#8B1538]/10 flex items-center justify-center">
                  <Users className="w-5 h-5 text-[#8B1538]" />
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-lg">B2B</div>
                  <div className="text-sm text-gray-600">Spezialisiert</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Visual Element */}
          <div className="relative hidden lg:block">
            <div className="relative">
              {/* Main Card */}
              <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
                <div className="space-y-6">
                  <div className="flex items-center justify-between pb-4 border-b border-gray-200">
                    <span className="text-sm font-semibold text-gray-500 uppercase tracking-wide">Unsere Stärken</span>
                    <span className="text-[#8B1538] font-bold">6 Gewerke</span>
                  </div>
                  
                  <div className="space-y-4">
                    {['Hochbau', 'Ausbau', 'Gala-Bau', 'Tiefbau', 'Bauelemente', 'Fliesen'].map((gewerk, index) => (
                      <div key={index} className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200">
                        <div className="w-2 h-2 rounded-full bg-[#8B1538]"></div>
                        <span className="text-gray-700 font-medium">{gewerk}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              {/* Floating accent */}
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-[#8B1538]/10 rounded-full blur-3xl"></div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-gray-300/30 rounded-full blur-3xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};